import { render, staticRenderFns } from "./ren-process-detail.vue?vue&type=template&id=374ce074&scoped=true"
import script from "./ren-process-detail.vue?vue&type=script&lang=js"
export * from "./ren-process-detail.vue?vue&type=script&lang=js"
import style0 from "./ren-process-detail.vue?vue&type=style&index=0&id=374ce074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374ce074",
  null
  
)

export default component.exports